module.exports = __webpack_public_path__ + "img/55ae272cf73f592e85c9e50d9165657f.svg";